import axios from 'axios';
import { ENV, VALID } from 'common/const';
import { getBaseUrl, log, scrubString } from 'common/utils';

import { ORDER } from 'routes/checkout/const';

import mock from './addAddress.mock';

const baseUrl = getBaseUrl(2);

/**
 * Adds a new address to DB
 * @param {object} param0 - contains address data and a customerId
 * @returns ID of new address
 */
const addAddress = async ({ type, address, customerId, ooId }) => {
  // console.log('$ addAddress', { type, address, customerId, ooId });

  await VALID.checkAll(
    ['customerId', customerId, VALID.CUSTOMER_ID],
    ['ooId', ooId, VALID.OO_SUMMARY_ID],
    ['type', type, VALID.ADDRESS_TYPE],
    ['address', address, VALID.OBJECT],
  );

  try {
    const { data } = ENV.IS_MOCK
      ? mock()
      : await axios.post(`${baseUrl}orders/add_address`, {
          address: {
            ...address,
            mobile: scrubString(address.mobile),
            phone: scrubString(address.phone),
          },
          customerId,
          ooId,
          type,
        });

    return {
      address,
      customerId,
      ooId,
      type,
      [ORDER.ADDRESS]: data.addressId,
    };
  } catch (error) {
    log('addAddress', {
      data: { type, address, customerId, ooId },
      error,
      throw: true,
      type: 'request',
    });
  }
};

export default addAddress;
